function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#596168",
  fillRule: "evenodd",
  d: "M7 5h5v2H7v5H5V7H0V5h5V0h2v5z"
});

var SvgNewSegmentMenuPlusIcon = function SvgNewSegmentMenuPlusIcon(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _ref);
};

export default SvgNewSegmentMenuPlusIcon;